/* sk-cookiebot-shopify.js - carry Cookiebot's answer into Shopify's Customer Privacy API.
 *
 * WHY THIS EXISTS. The Cookiebot app embed did this through its cb-embed.js, and the theme
 * now loads Cookiebot itself (snippets/sk-cookiebot.liquid), so the job moves here. Shopify
 * stores the answer in its own consent cookie and checkout enforces it: Customer Events
 * pixels and Shopify's own analytics run or don't based on it. It also fires
 * visitorConsentCollected, which assets/sk-klaviyo-consent.js waits on.
 *
 * Mapping, same as the app's: statistics -> analytics, marketing -> marketing,
 * preferences -> preferences. A GPC signal opts out of everything, sale_of_data included.
 */
(function () {
  var pending = null;
  var loading = false;

  function api() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return cp && typeof cp.setTrackingConsent === 'function' ? cp : null;
  }

  function flush() {
    if (!pending) return;
    var cp = api();
    if (cp) {
      var payload = pending;
      pending = null;
      try {
        cp.setTrackingConsent(payload, function () {});
      } catch (e) {}
      return;
    }
    if (loading || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    loading = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      loading = false;
      if (!error) flush();
    });
  }

  /* Only the latest answer matters, so a newer one replaces any that hasn't been sent yet. */
  function sync() {
    var c = window.Cookiebot && window.Cookiebot.consent;
    if (!c) return;
    pending = navigator.globalPrivacyControl
      ? { analytics: false, marketing: false, preferences: false, sale_of_data: false }
      : { analytics: !!c.statistics, marketing: !!c.marketing, preferences: !!c.preferences };
    flush();
  }

  window.addEventListener('CookiebotOnConsentReady', sync);
  window.addEventListener('CookiebotOnAccept', sync);
  window.addEventListener('CookiebotOnDecline', sync);

  /* uc.js is a blocking script, so for a returning visitor it can fire CookiebotOnConsentReady
   * before this deferred file adds its listeners. Read the answer it already has. */
  var cb = window.Cookiebot;
  if (cb && (cb.consented === true || cb.declined === true)) sync();
})();
